import { Outlet, useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import PlatformSidebar from "./PlatformSidebar";
import PlatformTopBar from "./PlatformTopBar";
import { useAuthStore } from "../../store/authStore";
import { useSwipeGesture } from "../../lib/useSwipeGesture";

/**
 * Dedicated shell for platform-admin panel. Separate from tenant AppShell —
 * has its own sidebar (Overview / Tenants / Users / Billing / Outbox /
 * Announcements / System / Audit / Digest) and no tenant-scoped widgets.
 */
export default function PlatformShell() {
  const { fetchMe } = useAuthStore();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    fetchMe?.();
  }, [location.pathname, fetchMe]);

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [sidebarOpen]);

  const closeSidebar = useCallback(() => setSidebarOpen(false), []);
  const openSidebar = useCallback(() => setSidebarOpen(true), []);

  useSwipeGesture({ open: sidebarOpen, onOpen: openSidebar, onClose: closeSidebar });

  return (
    <div className="min-h-screen bg-zinc-50" data-testid="platform-shell">
      <PlatformSidebar open={sidebarOpen} onClose={closeSidebar} />
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-30 bg-black/45 backdrop-blur-[2px] md:hidden"
          onClick={closeSidebar}
          data-testid="platform-sidebar-backdrop"
        />
      )}
      <div className="md:ml-64">
        <PlatformTopBar onMenuOpen={openSidebar} />
        <main className="p-4 sm:p-6 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
